<template>
  <div>
    <va-modal
      v-model="showFormationModel"
      :title="idformation_types ? 'Modifier un modèle de formation' : 'Ajouter un modèle de formation'"
      max-width="100%"
      noEscDismiss
      noOutsideDismiss
      hideDefaultActions
    >
      <div class="flex md 12">

      </div>
      <div class="row row-inside">
        <div class="flex md12 mx-2">
          <va-input
            v-model="newFormationType.name"
            placeholder="Nom de la formation"
            label="Nom de la formation"
          />
        </div>
        <div class="flex md12 mx-2">
          <va-input
            v-model="newFormationType.shortName"
            placeholder="Nom court de la formation"
            label="Nom court de la formation"
          />
        </div>
		        <div class="flex md12 mx-2">
          <va-input
            v-model="newFormationType.description"
            placeholder="Description / texte ajouté à l'attestation"
            label="Description de la formation"
          />
        </div>
        <div class="flex md12 mx-2">
			
          <va-select
            label="Niveau de la formation"
            textBy="label"
            keyBy="value"
            v-model="newFormationType.niveau"
            :options="niveauxOptions"
            no-clear
          />
        </div>
		 <div class="flex md12 mx-2">
          <va-select
            label="Modèle de feuille de présence"
            textBy="name"
            keyBy="iddocx_template"
            v-model="modelPresence"
            :options="listeModelsPresence"
            no-clear
          />
        </div>
        <div class="flex md12 mx-2">
          <va-input
            v-model="newFormationType.validite_mois"
            placeholder="Validité de la formation en mois / 0 pour illimité"
            label="Validité de la formation en mois / 0 pour illimité"
          />
        </div>
        <div class="flex md12 mx-2">
          <va-input
            v-model="newFormationType.duree_salarie"
            placeholder="Durée pour les salariés (en heures)"
            label="Durée pour les salariés (en heures)"
          />
        </div>
        <div class="flex md12 mx-2">
          <va-input
            v-model="newFormationType.duree_tns"
            placeholder="Durée pour les TNS (en heures)"
            label="Durée pour les TNS (en heures)"
          />
        </div>

        <!--<div class="flex md12 mx-2">
          <va-select
            label="Modèle d'attestation"
            textBy="name"
            keyBy="iddocx_template"
            v-model="newFormationType.idModel"
            :options="listeModelsAttestation"
            no-clear
          />
        </div>-->
      </div>
      <template v-slot:actions>
        <div style="display: flex; justify-content: flex-end; width: 100%;">
          <va-button color="gray" flat @click="closeModal">Annuler</va-button>
          <va-button @click="addFormationType">Sauvegarder</va-button>
        </div>
      </template>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["value", "idformation_types"],
  data() {
    return {
      showFormationModel: false,
      niveauxOptions: [
        { label: "Non applicable", value: 0 },
        { label: "Niveau 1", value: 1 },
        { label: "Niveau 2", value: 2 },
        { label: "Niveau 3", value: 3 },
        { label: "Niveau 4", value: 4 },
        { label: "Niveau 5", value: 5 },
      ],
      newFormationType: {
        name: null,
        shortName: null,
		description: null,
        niveau: { label: "Non applicable", value: 0 },
        validite_mois: 24,
        duree_salarie: null,
        duree_tns: null,
        idformation_types: null,
        idModel: 68,
		id_presence: null,
      },
	  modelPresence:{ "iddocx_template": null, 
	  	"name":null, 
		"template": null, 
		"type": null},
      idmodel: 68,
      listeModelsAttestation: [],
	  listeModelsPresence: [],
    }
  },
  mounted() {
    //this.getListTemplateAttestation();
	this.getListTemplatePresence();
  },
  methods: {
    async getFormationType() {
      try {
        let results = await axios.get("/api/afpf/formation-type-by-ids", {
          params: {
            idformation_types: this.idformation_types,
          },
        });
        console.log("results", results.data);
        if (results.data) {
          let formationType = results.data.formationType;
          // convert niveau to object
          let niveau = this.niveauxOptions.find(n => n.value === formationType.niveau);
          if (!niveau) {
            niveau = { label: "Non applicable", value: 0 };
          }

		  this.modelPresence = this.listeModelsPresence.find(m => m.iddocx_template === formationType.id_presence) || { "iddocx_template": null, "name": null, "template": null, "type": null };


          this.newFormationType = {
            name: formationType.name,
            shortName: formationType.shortname,
			description: formationType.description,
            niveau: niveau,
            validite_mois: formationType.validite_mois,
            duree_salarie: formationType.duree_salarie,
            duree_tns: formationType.duree_tns,
            idformation_types: formationType.idformation_types,
            idModel: this.idmodel,
            id_presence: formationType.id_presence,
          }
        }
      } catch (error) {
        this.launchEpicmaxToast("Erreur lors de la récupération du modèle de formation");
      }
    },
    closeModal() {
		this.modelPresence = { "iddocx_template": null, "name": null, "template": null, "type": null };
      this.newFormationType = {
        name: null,
        shortName: null,
		description: null,
        niveau: { label: "Non applicable", value: 0 },
        validite_mois: 24,
        duree_salarie: null,
        duree_tns: null,
        idformation_types: null,
        idModel: this.idmodel,
        id_presence: null,
      }
      this.$emit("input", false);
    },
    async addFormationType() {
      try {
        // check required fields
        if (!this.newFormationType.name || !this.newFormationType.shortName || !this.newFormationType.niveau || (!this.newFormationType.validite_mois && this.newFormationType.validite_mois !== 0) || !this.newFormationType.duree_salarie || !this.newFormationType.duree_tns || !this.newFormationType.idModel || !this.modelPresence.iddocx_template) {
          this.launchEpicmaxToast("Tous les champs sont obligatoires");

        } else {

          if (this.newFormationType.idformation_types) {
            // update
			this.newFormationType.id_presence = this.modelPresence.iddocx_template;
            await axios.put("/api/afpf/updateFormationType", this.newFormationType);
            this.launchEpicmaxToast("Modèle de formation mis à jour avec succès");
            this.$emit("update");


          } else {
            this.newFormationType.id_presence = this.modelPresence.iddocx_template;
            await axios.post("/api/afpf/addFormationType", this.newFormationType);
            this.launchEpicmaxToast("Modèle de formation ajouté avec succès");
            this.$emit("create");
          }


          this.closeModal();

        }

      } catch (error) {
        this.launchEpicmaxToast("Erreur lors de l'ajout du modèle de formation");
      }
    },
	async getListTemplatePresence(){
		try {
		let results = await axios.get("/api/afpf/getListModelsPresence");
		// trigger reactivity
		this.$set(this, 'listeModelsPresence', results.data);




	  } catch (error) {
		this.launchEpicmaxToast("Erreur lors de la récupération de la liste des modèles de feuille de présence");
	  }
	},
    async getListTemplateAttestation() {
      try {
        let results = await axios.get("/api/afpf/getListAttestationsModels");
        // trigger reactivity
        this.$set(this, 'listeModelsAttestation', results.data);

        console.log("listeModelsAttestation", this.listeModelsAttestation);
        if (this.listeModelsAttestation.length > 0 && !this.newFormationType.idModel) {
          this.newFormationType.idModel = this.listeModelsAttestation[0].iddocx_template;
        }

      } catch (error) {
        this.launchEpicmaxToast("Erreur lors de la récupération de la liste des modèles d'attestation");
      }
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  watch: {
    idformation_types() {
      console.log("idformation_types changed", this.idformation_types);
      if (this.idformation_types) {
        this.getFormationType();
      } else {
        this.newFormationType = {
          name: null,
          shortName: null,
		  description: null,
          niveau: { label: "Non applicable", value: 0 },
          validite_mois: 24,
          duree_salarie: null,
          duree_tns: null,
          idformation_types: null,
          idModel: this.idmodel,
		  id_presence: null,
        }
		this.modelPresence = { "iddocx_template": null, "name": null, "template": null, "type": null };

      }
    },
    value() {
      // Parent property changed; update internal variables
      this.showFormationModel = this.value;
      //  this.resetValues();
      if (this.idformation_types) {
        this.getFormationType();
        //this.getListTemplateAttestation();
      }

    }
  }

}
</script>

<style>
</style>